export const MANUFACTURING_BASE = "/manufacturing";

export const cellMfgPaths = {
  base: () => `${MANUFACTURING_BASE}/cell`,
  lots: () => `${MANUFACTURING_BASE}/cell/lots`,
  lotRegister: () => `${MANUFACTURING_BASE}/cell/lots/register`,
  lotDetail: (cellModelId: string, lotId: string, tabId?: string) =>
    `${MANUFACTURING_BASE}/cell/lots/${cellModelId}/${encodeURIComponent(lotId)}${tabId ? `/${tabId}` : ""}`,
  events: () => `${MANUFACTURING_BASE}/cell/events`,
  eventIngest: () => `${MANUFACTURING_BASE}/cell/events/ingest`,
  bulkUpload: () => `${MANUFACTURING_BASE}/cell/events/bulk-upload`,
  scrap: () => `${MANUFACTURING_BASE}/cell/scrap`,
  trace: () => `${MANUFACTURING_BASE}/cell/trace`,
  yieldAnalytics: (tabId?: string) =>
    `${MANUFACTURING_BASE}/cell/floor-intelligence/yield${tabId ? `/${tabId}` : ""}`,
  yieldInsight: (id: string) =>
    `${MANUFACTURING_BASE}/cell/floor-intelligence/yield/insights/${id}`,
  fieldImpact: () =>
    `${MANUFACTURING_BASE}/cell/field-intelligence/field-impact`,
};

export const batteryMfgPaths = {
  base: () => `${MANUFACTURING_BASE}/battery`,
  lots: () => `${MANUFACTURING_BASE}/battery/lots`,
  lotRegister: () => `${MANUFACTURING_BASE}/battery/lots/register`,
  lotDetail: (id: string, tabId?: string) =>
    `${MANUFACTURING_BASE}/battery/lots/${id}${tabId ? `/${tabId}` : ""}`,
};
